/* global google */
/* eslint react/no-did-mount-set-state: 0 */

import React, {Component} from 'react';
import injectMap from '@homeaway/react-google-maps/lib/transpiled/components/injectMap/injectMap.js';
import Marker from './Marker';
import {navigateCarousel, highlightInMap} from '../../../actions/greatPlaces';
import {pushEdapEvent} from '../../../utils/edap';

function calculateBounds(markers) {
    const {LatLngBounds, LatLng} = google.maps;

    return markers
        .map(({position}) => new LatLng(position.lat, position.lng))
        .reduce((bounds, point) => bounds ? bounds.extend(point) : null, new LatLngBounds());
}

const zoneOptions = {
    strokeColor: '#3E86D8',
    strokeOpacity: 1,
    strokeWeight: 0,
    fillColor: '#3E86D8',
    fillOpacity: 0.35,
    visible: false,
    radius: 500
};

function recordMapPinClick() {
    pushEdapEvent(
        'map.pin.click',
        {
            actionlocation: 'properties-map-module',
            pintype: 'property'
        }
    );
}

export function isListingsEqual(newListings, oldListings) {
    const newListingsId = newListings.map((item) => item.id);
    const oldListingsId = oldListings.map((item) => item.id);

    return newListingsId.reduce((result, item) => {
        if (oldListingsId.includes(item)) {
            return result;
        }
        return [...result, item];
    }, []).length === 0;
}

export class MarkerMapComponent extends Component {
    constructor() {
        super();
        this.state = {
            googleMap: null
        };
    }

    componentDidMount() {
        const {markers = []} = this.props;
        const bounds = calculateBounds(markers);
        const googleMap = new google.maps.Map(this.refs.mapContainer, {
            center: {lat: 0, lng: 0},
            zoom: 1,
            scrollwheel: false,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false
        });

        googleMap.fitBounds(bounds);
        this.setState({googleMap});
    }

    componentWillReceiveProps(nextProps) {
        if (!isListingsEqual(nextProps.listings, this.props.listings)) {
            this.refreshView(nextProps.markers);
        }
    }

    refreshView(markers = []) {
        const {googleMap} = this.state;
        const bounds = calculateBounds(markers);
        googleMap.fitBounds(bounds);
    }

    activateMarker(markerId) {
        const {dispatch} = this.props || {};
        if (dispatch) {
            return () => {
                recordMapPinClick();
                dispatch(navigateCarousel(markerId));
                dispatch(highlightInMap(markerId));
            };
        }
        return null;
    }

    render() {
        const {googleMap} = this.state;
        const {markers, highlightedId, clickableMarker = true} = this.props;

        const asPinMarker = (marker, index) => {
            const {id, key, label, position, showExactLocation} = marker;
            const isActive = key === highlightedId;
            const activeBonus = isActive ? markers.length : 0;

            const isActiveClass = isActive ? ' active' : '';
            const exactLocationClass = showExactLocation ? ' pinpoint' : '';
            const classNames = `labels${isActiveClass}${exactLocationClass}`;

            return (
                <Marker
                    key={`marker-${id}`}
                    id={id}
                    map={googleMap || null}
                    position={position}
                    content={`<span class="marker-content"><span class="text">${label}</span></span>`}
                    showZone={!showExactLocation}
                    zoneOptions={zoneOptions}
                    onClick={this.activateMarker(key)}
                    zIndex={index + activeBonus}
                    className={classNames}
                    clickable={clickableMarker}
                />
            );
        };

        return (
            <div
                ref="mapContainer"
                style={{
                    width: '100%',
                    height: '100%'
                }}
            >
                {googleMap ? markers.map(asPinMarker) : null}
            </div>
        );
    }
}

export default injectMap(MarkerMapComponent);
